module.exports = __webpack_public_path__ + "media/bootstrap-icons/rss-fill-41758b65.svg";